import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Checkbox from "rc-checkbox";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

import Layout1 from "../../assets/layout1.png";
import Layout2 from "../../assets/layout2.png";
import Layout3 from "../../assets/layout3.png";

class Options extends Component {
  render() {
    return (
      <div className="options-picker">
        <div className="info">
          <p>Pick a starmap layout</p>
          <div className="options">
            <div
              className={this.props.theme == 2 ? "option active" : "option"}
              onClick={() => {
                this.props.setCanvas({
                  ...this.props.canvas,
                  theme: 2
                });
              }}
            >
              <span>Invert</span>
              <i className="fa fa-check" />
              <img src={Layout1} alt="" />
            </div>
            <div
              className={this.props.theme == 1 ? "option active" : "option"}
              onClick={() => {
                this.props.setCanvas({
                  ...this.props.canvas,
                  theme: 1
                });
              }}
            >
              <span>Layout 1</span>
              <i className="fa fa-check" />
              <img src={Layout2} alt="" />
            </div>
            <div
              className={this.props.theme == 3 ? "option active" : "option"}
              onClick={() => {
                this.props.setCanvas({
                  ...this.props.canvas,
                  theme: 3
                });
              }}
            >
              <i className="fa fa-check" />
              <img src={Layout3} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas,
    theme: state.canvas.theme
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Options);

export default App;



// WEBPACK FOOTER //
// ./src/components/Options/index.js